import React, { FC, ReactNode } from 'react';
import classnames from 'classnames';

import styles from './index.module.css';

export interface SectionFieldsetWrapperProps {
  children?: ReactNode;
}

export const SectionFieldsetWrapper: FC<SectionFieldsetWrapperProps> = ({
  children,
}) => {
  return (
    <div className={classnames('box-border', 'space-y-9', styles['root'])}>
      {children}
    </div>
  );
};
